import { CerFormAdapter } from "@cer/cer-form/cer-form-adapter";
import { CerFormView } from "@cer/cer-form/cer-form-view";

export class SalesOrderLineTypeForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'salg-ordrelinje-typer', dataApiName: 'SalesOrderLineType', text: 'Salg ordrelinje typer',
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'history']
      },
      fieldMetadata: [
        { name: 'logisticsOutboundActive', text: 'Forsendes fra lager?', format: 'CheckBox' },
        { name: 'logisticsInboundActive', text: 'Returneres til lager?', format: 'CheckBox' },
        { name: 'isBundle', text: 'Skal udfoldes før forsendelse?', format: 'CheckBox' }
      ]
    });
  }
}
